var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPdfIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2596_631)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.9906 0H0.009375C0.00419733 0 0 0.00419733 0 0.009375V31.9906C0 31.9958 0.00419733 32 0.009375 32H31.9906C31.9958 32 32 31.9958 32 31.9906V0.009375C32 0.00419733 31.9958 0 31.9906 0Z",
    fill: "#C80A0A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8117 18.875C25.2492 18.25 23.9992 17.9375 22.3117 17.9375C21.3117 17.9375 20.2492 18.0625 18.9992 18.25C17.6757 17.0103 16.5762 15.5514 15.7492 13.9375C16.3742 12.0625 16.8117 10.25 16.8117 8.875C16.8117 7.8125 16.4367 6.125 14.9367 6.125C14.4992 6.125 14.1242 6.375 13.8742 6.75C13.2492 7.875 13.4992 10.375 14.6867 13C13.8193 15.5083 12.775 17.952 11.5617 20.3125C8.24921 21.6875 6.06171 23.1875 5.87421 24.375C5.74921 24.9375 6.12421 25.875 7.43671 25.875C9.37421 25.875 11.4992 23.0625 13.1242 20.1875C15.0001 19.5425 16.9223 19.041 18.8742 18.6875C21.2492 20.75 23.3117 21.0625 24.3117 21.0625C26.3117 21.0625 26.4992 19.625 25.8117 18.875ZM14.1867 6.9375C14.6867 6.1875 15.8117 6.4375 15.8117 7.9375C15.8117 8.9375 15.4992 10.5625 14.8742 12.4375C13.7492 9.8125 13.7492 7.75 14.1867 6.9375ZM6.24921 24.4375C6.43671 23.4375 8.31171 22.0625 11.2492 20.875C9.62421 23.625 7.99921 25.375 6.99921 25.375C6.37421 25.375 6.18671 24.8125 6.24921 24.4375ZM18.5617 18.3125C16.8006 18.6407 15.0666 19.1003 13.3742 19.6875C14.2993 18.0178 15.0531 16.2589 15.6242 14.4375C16.4457 15.8415 17.4318 17.1423 18.5617 18.3125ZM19.3742 18.5625C21.3742 18.25 23.0617 18.3125 23.8117 18.4375C25.6242 18.8125 24.9992 21 22.9992 20.5C21.5617 20.1875 20.3742 19.375 19.3742 18.5625Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2596_631"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 5,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfIcon);
export default __webpack_public_path__ + "static/media/pdf _icon.5ed96e4c30f39041e1879c4969577c35.svg";
export { ForwardRef as ReactComponent };